export default "__VITE_ASSET__DknKzkVJ__"